var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"d-flex":"","xs9":""}},[_c('v-breadcrumbs',{attrs:{"divider":"/"}},_vm._l((_vm.breadcrumbItems),function(item){return _c('v-breadcrumbs-item',{key:item.text,attrs:{"disabled":item.disabled,"to":item.link}},[_vm._v(" "+_vm._s(item.text)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }